import { render } from "./MyQRcode.vue?vue&type=template&id=4e7357c7"
import script from "./MyQRcode.vue?vue&type=script&lang=js"
export * from "./MyQRcode.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue_referralcode\\referral_code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__